import { render, staticRenderFns } from "./ManualsPanel.vue?vue&type=template&id=5d01a5c1&scoped=true&"
import script from "./ManualsPanel.vue?vue&type=script&lang=js&"
export * from "./ManualsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ManualsPanel.vue?vue&type=style&index=0&id=5d01a5c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01a5c1",
  null
  
)

export default component.exports